import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { AnimatePresence, m } from "motion/react";

import { Icon } from "src/design-system/Icon";

type ChatLoadingSpinnerProps = {
  text: string;
  dataLoc?: string;
};

export const ChatLoadingSpinner: React.FC<ChatLoadingSpinnerProps> = ({
  text,
  dataLoc,
}) => (
  <div className="flex items-center gap-x-2" data-loc={dataLoc}>
    <Icon icon={faSpinner} size="xs" spin />
    <AnimatePresence mode="wait">
      <m.span
        key={text}
        animate={{ opacity: 1 }}
        className="font-inter-medium-11px text-gray-600"
        exit={{ opacity: 0 }}
        initial={{ opacity: 0 }}
        transition={{ duration: 0.15, ease: "easeInOut" }}
      >
        {text}
      </m.span>
    </AnimatePresence>
  </div>
);
